// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Mobile Responsiveness Foundation
 * Shared utility classes + breakpoint-based overrides
 *
 * Breakpoints:
 *   480px  — small phone (iPhone SE)
 *   768px  — tablet / large phone
 *   1024px — desktop (existing)
 */

/* ============================================
   VISIBILITY UTILITIES
   ============================================ */

/* Hide on screens <= 768px */
@media (max-width: 768px) {
  .hide-mobile {
    display: none !important;
  }
}

/* Show ONLY on screens <= 768px */
.show-mobile-only {
  display: none !important;
}

@media (max-width: 768px) {
  .show-mobile-only {
    display: flex !important;
  }
}

/* ============================================
   LAYOUT UTILITIES
   ============================================ */

/* Stack children vertically on mobile */
@media (max-width: 768px) {
  .mobile-stack {
    flex-direction: column !important;
  }
}

/* Horizontal scroll row on mobile */
@media (max-width: 768px) {
  .mobile-scroll-row {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .mobile-scroll-row::-webkit-scrollbar {
    display: none;
  }

  .mobile-scroll-row > * {
    flex-shrink: 0;
  }
}

/* Table overflow wrapper — horizontal scroll for wide tables */
.table-overflow-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ============================================
   TOUCH TARGET ENFORCEMENT (44px minimum)
   Apple HIG + WCAG 2.5.5 Target Size
   ============================================ */

@media (max-width: 768px) {
  /* Buttons and interactive elements */
  .touch-target,
  button,
  [role="button"],
  a.nav-link,
  .quiz-option,
  .quiz-btn,
  .filter-btn,
  .deck-tab,
  .quest-card {
    min-height: 44px;
  }

  /* Ensure inline links/buttons are tappable */
  .dropdown-item {
    min-height: 48px;
  }
}

/* ============================================
   MODAL RESPONSIVENESS
   ============================================ */

@media (max-width: 768px) {
  /* Generic modal constraint — prevent overflow */
  .exam-modal,
  .modal-content,
  [class*="modal"]:not([class*="overlay"]):not([class*="backdrop"]) {
    max-width: calc(100vw - 2rem) !important;
    max-height: calc(100vh - 2rem) !important;
  }
}

/* ============================================
   IMAGE RESPONSIVENESS
   ============================================ */

@media (max-width: 768px) {
  img:not([class*="logo"]):not([class*="icon"]):not([class*="avatar"]) {
    max-width: 100% !important;
    height: auto !important;
  }
}

/* ============================================
   SAFE AREA (notch / home indicator)
   ============================================ */

@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .dashboard-hud,
  .fab,
  .options-bar {
    padding-bottom: env(safe-area-inset-bottom);
  }
}

/* ============================================
   PREVENT HORIZONTAL OVERFLOW
   ============================================ */

@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }
}

/* ============================================
   TOUCH DEVICE HOVER STATE FIXES
   Prevent sticky hover on touch screens
   ============================================ */

@media (hover: none) and (pointer: coarse) {
  .quest-card:hover {
    transform: none;
  }

  .phase-card:hover:not(.grayed-out) {
    transform: none;
  }

  .quiz-option:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.1);
    color: #d1d5db;
  }

  .quiz-option:active:not(:disabled) {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/mobile.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;;iDAEiD;;AAEjD,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;iDAEiD;;AAEjD,wCAAwC;AACxC;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;;iDAGiD;;AAEjD;EACE,qCAAqC;EACrC;;;;;;;;;IASE,gBAAgB;EAClB;;EAEA,6CAA6C;EAC7C;IACE,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,gDAAgD;EAChD;;;IAGE,wCAAwC;IACxC,yCAAyC;EAC3C;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;;;IAGE,2CAA2C;EAC7C;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;;iDAGiD;;AAEjD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;EAChB;AACF","sourcesContent":["/**\n * Mobile Responsiveness Foundation\n * Shared utility classes + breakpoint-based overrides\n *\n * Breakpoints:\n *   480px  — small phone (iPhone SE)\n *   768px  — tablet / large phone\n *   1024px — desktop (existing)\n */\n\n/* ============================================\n   VISIBILITY UTILITIES\n   ============================================ */\n\n/* Hide on screens <= 768px */\n@media (max-width: 768px) {\n  .hide-mobile {\n    display: none !important;\n  }\n}\n\n/* Show ONLY on screens <= 768px */\n.show-mobile-only {\n  display: none !important;\n}\n\n@media (max-width: 768px) {\n  .show-mobile-only {\n    display: flex !important;\n  }\n}\n\n/* ============================================\n   LAYOUT UTILITIES\n   ============================================ */\n\n/* Stack children vertically on mobile */\n@media (max-width: 768px) {\n  .mobile-stack {\n    flex-direction: column !important;\n  }\n}\n\n/* Horizontal scroll row on mobile */\n@media (max-width: 768px) {\n  .mobile-scroll-row {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .mobile-scroll-row::-webkit-scrollbar {\n    display: none;\n  }\n\n  .mobile-scroll-row > * {\n    flex-shrink: 0;\n  }\n}\n\n/* Table overflow wrapper — horizontal scroll for wide tables */\n.table-overflow-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ============================================\n   TOUCH TARGET ENFORCEMENT (44px minimum)\n   Apple HIG + WCAG 2.5.5 Target Size\n   ============================================ */\n\n@media (max-width: 768px) {\n  /* Buttons and interactive elements */\n  .touch-target,\n  button,\n  [role=\"button\"],\n  a.nav-link,\n  .quiz-option,\n  .quiz-btn,\n  .filter-btn,\n  .deck-tab,\n  .quest-card {\n    min-height: 44px;\n  }\n\n  /* Ensure inline links/buttons are tappable */\n  .dropdown-item {\n    min-height: 48px;\n  }\n}\n\n/* ============================================\n   MODAL RESPONSIVENESS\n   ============================================ */\n\n@media (max-width: 768px) {\n  /* Generic modal constraint — prevent overflow */\n  .exam-modal,\n  .modal-content,\n  [class*=\"modal\"]:not([class*=\"overlay\"]):not([class*=\"backdrop\"]) {\n    max-width: calc(100vw - 2rem) !important;\n    max-height: calc(100vh - 2rem) !important;\n  }\n}\n\n/* ============================================\n   IMAGE RESPONSIVENESS\n   ============================================ */\n\n@media (max-width: 768px) {\n  img:not([class*=\"logo\"]):not([class*=\"icon\"]):not([class*=\"avatar\"]) {\n    max-width: 100% !important;\n    height: auto !important;\n  }\n}\n\n/* ============================================\n   SAFE AREA (notch / home indicator)\n   ============================================ */\n\n@supports (padding-bottom: env(safe-area-inset-bottom)) {\n  .dashboard-hud,\n  .fab,\n  .options-bar {\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n}\n\n/* ============================================\n   PREVENT HORIZONTAL OVERFLOW\n   ============================================ */\n\n@media (max-width: 768px) {\n  body {\n    overflow-x: hidden;\n  }\n}\n\n/* ============================================\n   TOUCH DEVICE HOVER STATE FIXES\n   Prevent sticky hover on touch screens\n   ============================================ */\n\n@media (hover: none) and (pointer: coarse) {\n  .quest-card:hover {\n    transform: none;\n  }\n\n  .phase-card:hover:not(.grayed-out) {\n    transform: none;\n  }\n\n  .quiz-option:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.03);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: #d1d5db;\n  }\n\n  .quiz-option:active:not(:disabled) {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.2);\n    color: #ffffff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
